import { Actions } from '../../interfaces'
import { Channel } from '@/entities/crm'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { Channel },
  actions: { [Channel.name]: actions },
}
